import { CATEGORY_LIST_FAIL, CATEGORY_LIST_REQUEST, CATEGORY_LIST_SUCCESS } from "../constats/category.constant";

export const categoryListReducer = (state={}, action) => {
    switch (action.type) {
        case CATEGORY_LIST_REQUEST:
            return {
                loading: true
            };
        case CATEGORY_LIST_FAIL:
            return {
                loading: false,
                error: action.payload
            };
        case CATEGORY_LIST_SUCCESS:
            return {
                loading: false,
                data: action.payload
            };
        default:
            return state;
    }
}